// extracted by mini-css-extract-plugin
export default {"tableWrapper":"tableWrapper--e4ieT","wrap":"wrap--la3ut"};